// src/apps.js
// VentES Ecosystem Applications
const apps = [
  {
    id: "ventes-pet",
    name: "VentES PET",
    description: "Project Estimation Tool to plan, manage timelines, and estimate costs.",
    path: "/ventes-pet",
    category: "Project Management",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "📊",
    vendor: "VentES"
  },
  {
    id: "ventes-crm",
    name: "VentES CRM",
    description: "Manage customer relationships and track interactions.",
    path: "/ventes-crm",
    category: "Customer Management",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "👥",
    vendor: "VentES"
  },
  {
    id: "ventes-pay",
    name: "VentES PAY",
    description: "Simplify payroll management and processing.",
    path: "/ventes-pay",
    category: "Finance",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "💰",
    vendor: "VentES"
  },
  {
    id: "ventes-bil",
    name: "VentES BIL",
    description: "Manage billing and invoicing efficiently.",
    path: "/ventes-bil",
    category: "Finance",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "🧾",
    vendor: "VentES"
  },
  {
    id: "ventes-pos",
    name: "VentES POS",
    description: "Transform your device into a powerful POS system.",
    path: "/ventes-pos",
    category: "Sales",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "🛒",
    vendor: "VentES"
  },
  {
    id: "ventes-rat",
    name: "VentES RAT",
    description: "Review and Rating management system for customer feedback.",
    path: "/ventes-rat",
    category: "Analytics",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "⭐",
    vendor: "VentES"
  },
  {
    id: "ventes-buy",
    name: "VentES BUY",
    description: "Procurement and purchasing management system.",
    path: "/ventes-buy",
    category: "Procurement",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "🛍️",
    vendor: "VentES"
  },
  {
    id: "ventes-pem",
    name: "VentES PEM",
    description: "Project and Expense Management for comprehensive business oversight.",
    path: "/ventes-pem",
    category: "Project Management",
    status: "active",
    hasIntegration: true,
    integrationStatus: "available",
    icon: "📈",
    vendor: "VentES"
  }
];

export const categories = [
  "All",
  "Customer Management",
  "Project Management",
  "Finance",
  "Sales",
  "Analytics",
  "Procurement"
];

export default apps;
